export const LIST_EVENTS_OPTIONS = [
  "preventa.estado_actualizado",
  "proyecto.estado_pago_actualizado"
]